<template>
  <v-container fluid>
    <v-data-table
      :headers="itemHeader"
      :items="items"
      :loading="loading"
      :items-per-page="-1"
      class="elevation-1 "
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-7">
          <v-toolbar-title>Tags</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <!-- add / edit item component -->
          <ItemForm
            @closeDialog="openDialog = false"
            @formSubmitted="formSubmitted"
            :formTitle="formTitle"
            :dialog="openDialog"
            :record="record"
            :collection="collection"
            v-if="openDialog"
            :items="items"
          />
          <ProductForm
            @closeDialog="openDialog1 = false"
            @formSubmitted="formSubmitted"
            :dialog="openDialog1"
            :tag_id="record.id"
            v-if="openDialog1"
          />
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="
              () => {
                record = null;
                formTitle = 'Add New Item';
                openDialog = true;
              }
            "
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>

          <!-- delete item -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template
        v-slot:item.actions="{ item }"
        style="textAlign:right !important"
      >
        <v-icon color="primary" small class="mr-2" @click="editItem(item, 1)">
          mdi-pencil
        </v-icon>

        <v-icon color="primary" small class="mr-2" @click="editItem(item, 2)">
          mdi-plus
        </v-icon>

        <v-icon color="error" small class="mr-2" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ItemForm from "./comp/tagForm";
import ProductForm from "./comp/ProductForm";
import ApiService from "@/services/api.service";

export default {
  components: {
    ItemForm,
    ProductForm,
  },
  props: ["items", "itemHeader", "collection"],
  data() {
    return {
      loading: false,
      openDialog: false,
      openDialog1: false,
      dialogDelete: false,
      formTitle: "Add New Item",
      record: null,
    };
  },

  methods: {
    async loadData() {
      try {
        this.$emit("loadData");
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item, id) {
      this.record = item;
      this.formTitle = "Edit Record";
      if (id == 1) {
        this.openDialog = true;
      } else if (id == 2) {
        this.openDialog1 = true;
      }
    },

    deleteItem(record) {
      this.record = record;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        this.loading = true;
        const { data } = await ApiService.delete(
          `items/${this.collection}/${this.record.id}`
        );
        this.loading = false;
        this.closeDelete();
        let msg;
        msg = "deleted successfully";
        // }
        alert(msg);
        this.loadData();
      } catch (error) {
        console.log(error);
      }
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    formSubmitted(msg) {
      this.openDialog = false;
      this.openDialog1 = false;
      alert(msg);
      this.loadData();
    },
  },
  mounted() {
    // this.loadData();
  },
};
</script>

<style></style>
